export const Guide = () => {

    // タイトル設定
    document.title = "Guide | EarthUnity"

    return (
        <div>
            <div className="pageTitle">
                <div className="pageTitleContent">
                    <div className="pageTitleText">
                        <span>
                            <h2>サーバーの遊び方</h2>
                        </span>
                    </div>
                </div>
                <div className="pageTitleSpace"></div>
            </div>

            
        </div>
    );
}  